<!-- 下方信息栏 -->
<template>
  <div class="min-width">
    <a-flex class="content" justify="space-between" align="flex-top">
      <div>
        <a-flex align="center" class="left">
          <div
            v-for="item in title"
            :key="item.id"
            class="card"
            @click="gotoPage(item.name)"
          >
            {{ item.title }}
          </div>
        </a-flex>
        <div class="border"></div>
        <div class="address">
          <a-flex align="center" class="address-top">
            <div>地址：山东省烟台市芝罘区南大街11号壹通国际21楼</div>
          </a-flex>
          <a-flex align="center">
            <div class="address-left">电话：（0535）6233306</div>
            <div>网址：www.wozhida.cn</div>
          </a-flex>
        </div>
      </div>
      <CompanyIcon class="right" pattern="white" size="irregular"></CompanyIcon>
    </a-flex>
    <div class="info">
      山东沃智达技术有限公司 Copyright @ 2021 沃智达. All Rights Reserved
      | www.wozhida.cn
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import CompanyIcon from "./CompanyIcon.vue";
import { title } from "@/common/param";
import { useRouter } from "vue-router";

export default defineComponent({
  components: {
    CompanyIcon,
  },
  name: "TopBar",
  setup(props, ctx) {
    const router = useRouter();
    function gotoPage(name: any) {
      router.push("/" + name);
    }
    return { title, gotoPage };
  },
});
</script>

<style scoped lang="scss">
.min-width {
  width: 1920px;
  min-width: 1024px;
}
.content {
  // width: 1920px;
  padding: 70px 0 53px 0;
  background: #333333;
  .right {
    margin-right: 324px;
  }
  .left {
    margin-left: 187px;
    .card {
      padding: 10px 0;
      font-weight: 400;
      font-size: 14px;
      color: #cccccc;
      cursor: pointer;
      margin-left: 138px;
    }
  }
  .border {
    width: 833px;
    height: 1px;
    background-color: #444444;
    margin-left: 324px;
    margin-top: 35px;
  }
  .address {
    cursor: default;
    margin-left: 324px;
    font-weight: 400;
    font-size: 12px;
    color: #cccccc;
    &-top {
      margin-top: 39px;
      margin-bottom: 18px;
    }
    &-left {
      margin-right: 78px;
    }
  }
}
.info {
  cursor: default;
  padding: 28px 0;
  // width: 1920px;
  background: #282828;
  font-weight: 400;
  font-size: 12px;
  color: rgba(153, 153, 153, 0.53);
}
</style>
